import { render } from "./SubmitOtp.vue?vue&type=template&id=3f2655e6&scoped=true"
import script from "./SubmitOtp.vue?vue&type=script&lang=js"
export * from "./SubmitOtp.vue?vue&type=script&lang=js"

import "./SubmitOtp.vue?vue&type=style&index=0&id=3f2655e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2655e6"]])

export default __exports__